import { createContext, useContext, useEffect, useState, useCallback } from "react";

import {
    onAuthStateChanged,
    signInWithPopup,
    signInWithRedirect,
    getRedirectResult,
    signOut
} from "firebase/auth";

import { auth, provider } from "./Firebase";

const BACKEND = process.env.REACT_APP_PUBLIC_URL
    ? "https://myprofilecorner.com/api"
    : "http://localhost:3001";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = loading
    const [isPremium, setIsPremium] = useState(false);
    const [premiumPlan, setPremiumPlan] = useState(null);
    const [premiumExpiry, setPremiumExpiry] = useState(null);

    const loadPremium = useCallback(async (uid) => {
        try {
            const res = await fetch(`${BACKEND}/premium-status/${uid}`);
            const data = await res.json();

            setIsPremium(data.isPremium || false);
            setPremiumPlan(data.plan || null);
            setPremiumExpiry(data.premiumExpiry || null);

            return data.isPremium || false;
        } catch (error) {
            console.error("Premium status error:", error);
            setIsPremium(false);
            return false;
        }
    }, []);

    useEffect(() => {
        getRedirectResult(auth).catch((error) => {
            console.error("Google redirect login error:", error);
        });
    }, []);

    useEffect(() => {
        const unsub = onAuthStateChanged(auth, (u) => {
            setUser(u || null);

            if (u) {
                loadPremium(u.uid);
            } else {
                setIsPremium(false);
                setPremiumPlan(null);
                setPremiumExpiry(null);
            }
        });

        return unsub;
    }, [loadPremium]);

    const signInWithGoogle = async () => {
        if (auth.currentUser) return Promise.resolve();

        try {
            await signInWithPopup(auth, provider);
        } catch (err) {
            console.error("Google popup login error:", err);

            if (
                err.code === "auth/popup-blocked" ||
                err.code === "auth/popup-closed-by-user" ||
                err.code === "auth/cancelled-popup-request" ||
                err.code === "auth/operation-not-supported-in-this-environment"
            ) {
                return signInWithRedirect(auth, provider);
            }

            throw err;
        }
    };

    const logout = () => signOut(auth);

    const refreshPremium = () =>
        user ? loadPremium(user.uid) : Promise.resolve(false);

    return (
        <AuthContext.Provider
            value={{
                user,
                isPremium,
                premiumPlan,
                premiumExpiry,
                signInWithGoogle,
                logout,
                refreshPremium
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}


// import { createContext, useContext, useEffect, useState, useCallback } from "react";
// import { onAuthStateChanged, signInWithPopup, signOut } from "firebase/auth";
// import { auth, provider } from "./Firebase";

// const BACKEND = process.env.REACT_APP_PUBLIC_URL
//     ? "https://myprofilecorner.com/api"
//     : "http://localhost:3001";

// const AuthContext = createContext(null);

// export function AuthProvider({ children }) {
//     const [user, setUser]           = useState(undefined); // undefined = loading
//     const [isPremium, setIsPremium] = useState(false);
//     const [premiumPlan, setPremiumPlan]     = useState(null);
//     const [premiumExpiry, setPremiumExpiry] = useState(null);

//     const loadPremium = useCallback(async (uid) => {
//         try {
//             const res  = await fetch(`${BACKEND}/premium-status/${uid}`);
//             const data = await res.json();
//             setIsPremium(data.isPremium || false);
//             setPremiumPlan(data.plan || null);
//             setPremiumExpiry(data.premiumExpiry || null);
//             return data.isPremium || false;
//         } catch {
//             setIsPremium(false);
//             return false;
//         }
//     }, []);

//     useEffect(() => {
//         const unsub = onAuthStateChanged(auth, (u) => {
//             setUser(u || null);
//             if (u) loadPremium(u.uid);
//             else { setIsPremium(false); setPremiumPlan(null); setPremiumExpiry(null); }
//         });
//         return unsub;
//     }, [loadPremium]);

//     const signInWithGoogle = () => {
//         // Prevent double-popup (causes auth/cancelled-popup-request)
//         if (auth.currentUser) return Promise.resolve();
//         return signInWithPopup(auth, provider).catch((err) => {
//             if (err.code !== "auth/cancelled-popup-request" && err.code !== "auth/popup-closed-by-user") throw err;
//         });
//     };
//     const logout = () => signOut(auth);
//     const refreshPremium   = () => user ? loadPremium(user.uid) : Promise.resolve(false);

//     return (
//         <AuthContext.Provider value={{ user, isPremium, premiumPlan, premiumExpiry, signInWithGoogle, logout, refreshPremium }}>
//             {children}
//         </AuthContext.Provider>
//     );
// }

// export function useAuth() {
//     return useContext(AuthContext);
// }
